"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _componentCommon = require("./component-common");

var _errorMessages = _interopRequireDefault(require("./error-messages"));

var _help = _interopRequireDefault(require("./help"));

var _row = _interopRequireDefault(require("./row"));

var _icon = _interopRequireDefault(require("./icon"));

var _inputFile = _interopRequireDefault(require("./controls/input-file"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var File = /*#__PURE__*/function (_Component) {
  _inherits(File, _Component);

  var _super = _createSuper(File);

  function File() {
    var _this;

    _classCallCheck(this, File);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var target = event.currentTarget;
      var value = target.value;
      var _this$props = _this.props,
          onSetValue = _this$props.onSetValue,
          onChange = _this$props.onChange,
          name = _this$props.name;
      onSetValue(target.files); // We're passing an additional argument to the onChange handler here,
      // the 'value' of the field. This value is actually pretty useless,
      // and we're only including here for completeness.
      // An example value would be: "C:\fakepath\name-of-file.txt". Note that
      // if we select multiple files, it only returns a "fakepath" string for
      // the first file.
      // A web search for "C:\fakepath\" gives more details.

      onChange(name, target.files, value);
    });

    _defineProperty(_assertThisInitialized(_this), "initElementRef", function (control) {
      _this.element = control ? control.element : null;
    });

    return _this;
  }

  _createClass(File, [{
    key: "render",
    value: function render() {
      var inputProps = Object.assign({}, this.props);
      Object.keys(_componentCommon.componentPropTypes).forEach(function (key) {
        delete inputProps[key];
      });
      var _this$props2 = this.props,
          layout = _this$props2.layout,
          id = _this$props2.id,
          showErrors = _this$props2.showErrors,
          help = _this$props2.help,
          errorMessages = _this$props2.errorMessages;

      var control = /*#__PURE__*/_react["default"].createElement(_inputFile["default"], _extends({}, inputProps, {
        onChange: this.handleChange,
        ref: this.initElementRef
      }));

      if (layout === 'elementOnly') {
        return control;
      }

      return /*#__PURE__*/_react["default"].createElement(_row["default"], _extends({}, this.props, {
        htmlFor: id
      }), control, showErrors ? /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        symbol: "remove",
        className: "form-control-feedback"
      }) : null, help ? /*#__PURE__*/_react["default"].createElement(_help["default"], {
        help: help
      }) : null, showErrors ? /*#__PURE__*/_react["default"].createElement(_errorMessages["default"], {
        messages: errorMessages
      }) : null);
    }
  }]);

  return File;
}(_react.Component);

File.propTypes = _objectSpread(_objectSpread({}, _inputFile["default"].propTypes), _componentCommon.componentPropTypes);
File.defaultProps = _objectSpread({}, _componentCommon.componentDefaultProps);
var _default = File;
exports["default"] = _default;